<template>
  <div class="share">
    <el-button
      :class="{ 'screen-share-active': isScreenStream }"
      @click="shareScreen(isScreenStream = !isScreenStream)"
      circle
    >
      <img :src="require(`@/assets/img/share_${shareIcon}@2x.png`)" />
    </el-button>
    <p>{{ $t('buttons.share') }}</p>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { isScreenShareAudioSupported } from '@/utils/screenShareAudioSupport';

export default {
  data() {
    return {
      isScreenStream: false
    };
  },
  watch: {
    chimeShareScreenDidStop(val) {
      if (!val) {
        return;
      }
      this.isScreenStream ? this.shareScreen(false) : this.setChimeShareScreenDidStop(false);
    }
  },
  computed: {
    ...mapState('videoRtc', ['rtcClient', 'localUser', 'chimeShareScreenDidStop']),
    ...mapState('layout', ['layoutColor']),
    ...mapState('socketio', ['socket']),
    ...mapState(['isTrial', 'isTest', 'lessonId']),

    shareIcon() {
      return this.isScreenStream ? 'dark' : this.layoutColor;
    }
  },
  methods: {
    ...mapMutations('videoRtc', ['setLocalUserStream', 'setIsShareScreenOn', 'setChimeShareScreenDidStop']),
    ...mapMutations('layout', ['setIsLocalFitted']),

    /**
     * Start or Stop Share Screen
     *
     * @param boolean mode
     */
    emitReset() {
      this.$logger.info(`Emit reset when using safari on trial/test lesson`, { operation: 'webrtc:share-screen' });
      this.$emit('reset');
    },
    async shareScreen(mode) {
      if (mode && !isScreenShareAudioSupported()) {
        this.$notify({
          title: this.$t('screenShareAudioNotification.title'),
          message: this.$t('screenShareAudioNotification.message'),
          type: 'info',
          position: 'bottom-right',
          duration: 10000
        });
      }

      let screenStream = await this.rtcClient.shareScreen(mode);

      if (!screenStream.error) {
        this.setLocalUserStream(screenStream);
        if (mode) {
          // Skyway: on stop screen sharing for chrome
          this.localUser.stream.getVideoTracks()[0].onended = async () => {
            this.shareScreen(false);
          };
          this.setIsLocalFitted(false);
        }
        this.isScreenStream = mode;

        const state = mode ? 'starts' : 'stops';
        this.$logger.info(`User ${state} share screen`, { operation: 'webrtc:share-screen' });
      } else {
        this.isScreenStream = false;
        this.$logger.error('Share screen error', {
          operation: 'webrtc:share-screen',
          reason: screenStream.error,
          event_type: 6,
          lesson_id: this.lessonId
        });
      }
      this.setIsShareScreenOn(this.isScreenStream);
      this.socket.emit('signal', { type: 'share-screen', state: this.isScreenStream });
    }
  }
};
</script>
